module.exports = __webpack_public_path__ + "img/nz_banner_deep.23c2edd4.png";